import { useQuery } from "@tanstack/react-query";
import {
	getAgentAssignedV2,
	type UserAgentStatusEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import { AdvisorKeys } from "./AdvisorKeys";

export const useAssignedAgentsQuery = (filterStatus?: UserAgentStatusEnum) => {
	return useQuery({
		queryKey: AdvisorKeys.assigned(filterStatus),
		queryFn: processResponse(() => getAgentAssignedV2(filterStatus)),
	});
};
